import {createProcessModel,loadProcessModdle} from './moddleUtils';
import {loadForm} from './formLoader.js';


export async function loadProcess(dispatch,processID,activeState)
	{
	var moddle=await loadProcessModdle(dispatch,processID);

	if (!moddle)
		return emptyProcess();

	var processModel=createProcessModel(moddle);
	var activeElement=processModel.findElement(activeState);

	if (!activeElement)
		{
		console.error("Unable to locate event",activeState);
		return emptyProcess();
		}

	var variables=processModel.getVariables();
	var ownerGroup=processModel.getStateOwner(activeState);
	var processName=activeElement.name||activeElement.id;
	var formID=activeElement.spell||"__DefaultForm";
	var schema=await loadForm(dispatch,formID,variables);

	return {
		schema,
		ownerGroup,
		processName,
		processModel,
		processId:processID
		};
	}


function emptyProcess()
	{
	return {
		schema:null,
		ownerGroup:null,
		processName:null,
		processModel:null,
		processId:null
		};
	}